import { REGEX } from 'src/constants/regex'
import I18NextVue from 'i18next'

export default function useValidation() {
  const { t, language } = I18NextVue
  const options = { ns: language }
  const EMAIL_MAX_LENGTH = 65

  function getEmailValidation() {
    return {
      required: (val: string | null) => !!val || t('Укажите почту', options),
      onlyEn: (val: string) => !REGEX.ru.test(val) || t('Используйте только латиницу', options),
      regex: (val: string) => REGEX.email.test(val.trim()) || t('Некорректный email', options),
      maxLength: (val: string) => val.length <= EMAIL_MAX_LENGTH || `${t('Должно быть не больше', options)} ${EMAIL_MAX_LENGTH} ${t('символов', options)}`,
    }
  }

  const PASSWORD_LENGTH = {
    max: 32,
    min: 8,
  }

  function getPasswordValidation() {
    return {
      required: (val: string | null) => !!val || t('Введите пароль', options),
      minLength: (val: string) => val.length >= PASSWORD_LENGTH.min || t('От {count} символов', { ...options, count: PASSWORD_LENGTH.min }),
      maxLength: (val: string) => val.length <= PASSWORD_LENGTH.max || t('Должно быть не больше {count} символов', { ...options, count: PASSWORD_LENGTH.max }),
      onlyLettersAndDigits: (val: string) => (
        /[A-Z]/.test(val) && /\d/.test(val) && !REGEX.invalidPassword.test(val)
      ) || t('От {count} символов с хотя бы одной цифрой и одной заглавной буквой, только латиница', { ...options, count: PASSWORD_LENGTH.min }),
    }
  }

  function getValidators() {
    return {
      required: (message: string) => (val: string | null) => !!val || message,
      containsLettersAndDigits: (message: string) => (val: string) => (/[A-z]/.test(val) && /\d/.test(val)) || message,
      minLength: (length: number) => (val: string) => val.length >= length || t('Должно быть не меньше {length} символов', { ...options, length }),
      maxLength: (length: number) => (val: string) => val.length <= length || t('Должно быть не больше {length} символов', { ...options, length }),
    }
  }

  return {
    getEmailValidation,
    getPasswordValidation,
    getValidators,
  }
}
